import React, { useRef } from "react";
import { ExternalLink } from "lucide-react";
import { AiFillGithub } from "react-icons/ai";

const ProjectCard = ({ title, description, techStack, githubUrl, liveUrl, image }) => {
  return (
    <div className="project-card">
      <div className="card-image">
        <img src={image} alt={title} />
      </div>
      <div className="card-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="tech-stack">
          {techStack.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="card-buttons">
          <a href={githubUrl} target="_blank" rel="noreferrer" className="btn-github">
            <AiFillGithub size={18} />
            <span>GitHub</span>
          </a>
          <a href={liveUrl} target="_blank" rel="noreferrer" className="btn-live">
            <ExternalLink size={18} />
            <span>Live Demo</span>
          </a>
        </div>
      </div>
    </div>
  );
};

const ProjectCards = () => {
  const headingRef = useRef(null);
  const subheadingRef = useRef(null);
  const cardsRef = useRef([]);

 

  const projects = [
     {
      title: "Internee.pk",
      description: "I've successfully completed my first task, marking a tangible step in connecting learning with real-world application. Internee.pk's dynamic, real-world approach, combined with my practice and dedication, made every task an invaluable learning experience for growth.💡",
      techStack: ["React", "Tailwind CSS", "Firstintership"],
      githubUrl: "https://github.com/Shibilkhan999/internee.pk",
      liveUrl: "https://internee-pk-xi.vercel.app/",
      image: "internee1.png"
    },
    {
      title: "E-Commerce Platform",
      description: "A responsive e-commerce app built with React, Tailwind CSS, Firebase, and GSAP — featuring smooth animations, secure auth, and an Admin Dashboard for product and order management.",
      techStack: ["React", "Firebase", "Tailwind CSS", "GSAP"],
      githubUrl: "https://github.com/Shibilkhan999/Shop.co",
      liveUrl: "https://shop-co-silk-chi.vercel.app/",
      image: "front.png", 
    },
    {
      title: "Weather App",
      description: "Get live weather updates with real-time temperature, humidity, wind speed, and visibility. Track today’s forecast, hourly changes, and upcoming weather — all in a sleek, easy-to-use app designed to keep you prepared every day.",
      techStack: ["Next.js", "Tailwind CSS", "React"],
      githubUrl: "https://github.com/Shibilkhan999/weather",
      liveUrl: "https://weather-11.vercel.app/",
      image: "https://cdn.dribbble.com/userupload/37779508/file/original-271b52a482c3743e7acb5e421bff6b21.jpg?resize=400x0"
    },
    
    {
      title: "Call Of Duty",
      description: "A clean and fast social app featuring secure Firebase authentication, user profile management, and real-time post creation with full edit/delete control. Designed with a responsive, modern UI.",
      techStack: ["React", "Firebase", "Tailwind CSS"],
      githubUrl: "https://github.com/Shibilkhan999/call-of-duty",
      liveUrl: "https://call-of.vercel.app/signup",
      image: "https://legacymedia.sportsplatform.io/image/upload/v1730251888/khtfm79sm3ybyt2idtkm.jpg"
    },
    {
      title: "Portfolio ",
      description: "A dynamic portfolio generator built with React, featuring customizable themes, templates, and a fully responsive UI.",
      techStack: ["React", "Gsap", "Tailwind CSS"],
      githubUrl: "https://github.com/yourusername/portfolio-builder",
      liveUrl: "https://your-portfolio-demo.com",
      image: "portfolio.png"
    },
    {
      title: "Facebook clone",
      description: "A responsive Facebook UI clone built with React, focused on clean components, efficient state management, and modern UI design.",
      techStack: ["React", "CSS", "Firebase"],
      githubUrl: "https://github.com/Shibilkhan999/F-b-clone",
      liveUrl: "https://f-b-clone-nine.vercel.app/LoginPage",
      image: "facebook.png"
    }
  ];

  return (
    <div className="projects-section">
      <div className="projects-header">
        <h1 ref={headingRef}>
          My Recent <span className="highlight-purple">Works</span>
        </h1>
        <p ref={subheadingRef}>Here are a few projects I've worked on recently.</p>
      </div>
      
      <div className="projects-container">
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} ref={el => cardsRef.current[index] = el}>
              <ProjectCard {...project} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectCards;